<script>
    // правда или миф

    export let wrapper;
    export let data;
    export let reward;
    const check = () => {
        return true;
    }
    
    let bonus = 0;
    let questions = [...data.options];
    let question = questions.shift();
    
    const handlerNext = (value) => {
        let qw = wrapper.querySelector('[data-question]'),
            qbtn = wrapper.querySelectorAll('button'),
            progress = wrapper.querySelector('.progress-bar');
    
        qbtn.forEach(el => {el.disabled = true});
        
        if (question.answer.toString() === value.toString()) {
            qw.classList.add('border-bottom', 'border-3', 'border-success');
            bonus += +question.bonus;
        } else {
            qw.classList.add('border-bottom', 'border-3', 'border-danger');
        }
    
        progress.style = 'width: ' + ((data.options.length - questions.length) * 100 / data.options.length) + '%';
    
        setTimeout(() => {
            qbtn.forEach(el => {el.disabled = false});
            qw.classList.remove('border-bottom', 'border-3', 'border-success', 'border-danger');
            
            if (questions.length) {
                question = questions.shift();
            } else {
                reward(bonus);
            }
        }, 1000);
    };
</script>

<div>
    <div class="progress mb-3">
        <div class="progress-bar progress-bar-striped bg-success" role="progressbar" style="width: 0%"></div>
    </div>
    
    <div class="card" data-question>
        <div class="card-body">
            <h5 class="card-title text-md-center m-0">{question.label}</h5>
        </div>
    </div>
    
    <div class="row mt-3">
        <div class="col-6">
            <button type="button" class="btn btn-danger btn-block btn-lg" on:click={() => handlerNext(0)}>Миф</button>
        </div>
        <div class="col-6">
            <button type="button" class="btn btn-success btn-block btn-lg" on:click={() => handlerNext(1)}>Правда</button>
        </div>
    </div>
</div>
